import { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { useOrder } from "../../../hook/useOrder";
import { Link, useNavigate } from "react-router-dom";
import InfoIcon from "../../InfoIcon";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import PayPal from "../../PayPal";

export function ShoppingCart() {
  let cartItems = useSelector((state) => state.order.cartOrders);

  let totalCartPrice = useSelector((state) => state.order.cartItemsTotalPrice);

  let navigate = useNavigate();

  useEffect(() => {
    if (cartItems && cartItems.length === 0) {
      navigate("/products");
    }
  }, [cartItems, navigate]);

  const cartElements = cartItems?.map((item) => (
    <CartItem key={item.product.id} item={item} />
  ));

  return (
    <Fragment>
      <div className="table-responsive cart-table">
      <table className="table table-striped table-bordered align-middle">
        <thead>
          <tr>
            <th>Title</th>
            <th>Count</th>
            <th>Price</th>
            <th>Total</th>
            <th>Remove</th>
          </tr>
        </thead>
        <tbody>{cartElements}</tbody>
      </table>
      </div>
      <p className="cart-total">Total Price: {totalCartPrice} €</p>
      <PayPal />
    </Fragment>
  );
}

function CartItem(props) {
  const { item } = props;
  const isFixedValidity = Number(item.product.validity_mode) === 1;

  const [count, setCount] = useState(item.count);
  const [totalPrice, setTotalPrice] = useState(item.product.price * item.count);

  const { updateCartItems } = useOrder();

  const [disabled, setDisabled] = useState(false);
  const [inputMethod, setInputMethod] = useState("mouse");
  const [pressedKey, setPressedKey] = useState(null);

  useEffect(() => {
    let canUpdate = false;

    if (
      inputMethod === "mouse" ||
      (inputMethod === "keyboard" && pressedKey === 13)
    ) {
      canUpdate = true;
    }

    if (canUpdate) {
      let newCartItem = {
        product: item.product,
        count: count,
      };
      updateCartItems(newCartItem);

      setTotalPrice(item.product.price * count);
    }
    
  }, [count,pressedKey]);

  return (
    <Fragment>
      {count > 0 && (
        <tr>
          <td>
            <Link
              to={`/products/${item.product.id}`}
              state={{
                product: item.product,
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                {item.product.title}
                <img className="cart-product-image" src={`${item.product.image}`} alt={item.product.title} />
              </div>
            </Link>
          </td>
          <td>
            <input
              value={count}
              type="number"
              min={0}
              disabled={disabled || isFixedValidity}
              onChange={(event) => {
                if (inputMethod === "mouse") {
                  setDisabled(true);
                }
                setCount(parseInt(event.target.value));
                setTimeout(() => {
                  setDisabled(false);
                }, 1000);
              }}
              onMouseDown={() => {
                setInputMethod("mouse");
              }}
              onKeyDown={(event) => {
                setInputMethod("keyboard");
                setPressedKey(event.keyCode);
              }}
            />
            {isFixedValidity && <small className="d-block text-muted">Feste Laufzeit</small>}
          </td>
          <td>{item.product.price} €</td>
          <td>{totalPrice} €</td>
          <td>
            <button
              type="button"
              className="btn btn-warning"
              onClick={() => {
                setCount(0);
              }}
            >
              <InfoIcon icon={faTrash} title="remove cart item" />
            </button>
          </td>
        </tr>
      )}
    </Fragment>
  );
}
